import React from 'react';

const steps = [
  {
    number: '01',
    title: 'Contacto',
    meta: 'Sem compromisso',
    description: 'Envie o seu pedido através do formulário ou WhatsApp, com a morada e tipologia do imóvel. Sem custos nem compromisso.'
  },
  {
    number: '02',
    title: 'Orçamento em 24h',
    meta: '24 horas',
    description: 'Recebe uma proposta rigorosa e transparente, ajustada à tipologia, localização e complexidade do imóvel.'
  },
  {
    number: '03',
    title: 'Vistoria Técnica',
    meta: 'Visita presencial',
    description: 'Deslocação ao imóvel para levantamento técnico completo: medições, registo fotográfico e verificação documental.'
  },
  {
    number: '04',
    title: 'Relatório Certificado',
    meta: '5–8 dias úteis',
    description: 'Entrega do relatório oficial assinado digitalmente, fundamentado e verificável, apto a ser apresentado a bancos, notários e tribunais.'
  }
];

export const ProcessSection = () => (
  <section className="vjr-process-section" id="processo" data-testid="process-section">
    <div className="vjr-process-inner">
      <div className="valuare-section-label">Processo</div>
      <h2 className="valuare-section-title">
        Como <em>Funciona</em>
      </h2>
      <div className="vjr-process-grid">
        {steps.map((step) => (
          <div key={step.number} className="vjr-process-step" data-testid={`process-step-${step.number}`}>
            <div className="vjr-process-num">{step.number}</div>
            <div className="vjr-process-meta">{step.meta}</div>
            <h3>{step.title}</h3>
            <p>{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
